import './sentry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { StoreProvider } from '@core';
import { AppErrorBoundary } from './AppErrorBoundary.tsx';

console.log('ticket-widget-ui version:', __APP_VERSION__);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <StoreProvider>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StoreProvider>
  </StrictMode>
);
